// extracted by mini-css-extract-plugin
export default {"header":"app-organizations-OrganizationMemberTable-OrganizationMemberTable-module__A8ksB9RnSx05hgWn1P0m"};